import React from 'react'
import { FilterDropdownItem } from './FilterDropdownItem'
import { FilterDropdownBtn } from './FilterDropdownBtn'
import { add, has, remove } from '../../setUtils'
import classNames from 'classnames'

export function FilterDropdown({
  optionsCount,
  value,
  onChange,
  productCount,
  onViewProductsClick,
  whiteBackground = false,
  isModels
}) {
  return (
    <div className={classNames('mtt-filter__dropdown', { white: whiteBackground, 'full-width': isModels })}>
      {optionsCount.map((option, index) => (
        <FilterDropdownItem
          key={index}
          optionCount={option}
          onChange={(e) => {
            if (e.target.checked) {
              onChange(add(option.term_id)(value))
            } else {
              onChange(remove(option.term_id)(value))
            }
          }}
          checked={has(option.term_id)(value)}
        />
      ))}
      <FilterDropdownBtn productCount={productCount} onViewProductsClick={onViewProductsClick} />
    </div>
  )
}
